import {needAuth} from "../instance/Instance";
import {apiRequest} from "../../components/Utils/SimmsUtils";

async function getServiceCodeStatic(querySelector) {
    const search = {
        querySelector: querySelector
    }
    try {
        return await needAuth.post('/statics/service/serviceCode', search);
    } catch (error) {
        return error;
    }
}

async function getServiceDetail() {
    try {
        return await needAuth.get('/statics/service/service-detail');
    } catch (error) {
        return error;
    }
}

async function getServiceByStatus(querySelector) {
    const search = {
        querySelector: querySelector
    }
    try {
        return await needAuth.post('/statics/service/serviceByStatus', search);
    } catch (error) {
        return error;
    }
}

const getTimelyThroughput = async () => {
    try {
        return await needAuth.get('/statics/service/timelyThroughput');
    } catch (error) {
        return error;
    }
}

const getRequestDoneCountByCode = async (serviceCurrent) => {
    try {
        return await needAuth.post('/statics/service/requestDoneCountByCode', serviceCurrent);
    } catch (error) {
        return error;
    }
}

const getRequestDoneCountByHandlerDept = async () => {
    try {
        return await needAuth.get('/statics/service/requestDoneCountByHandlerDept');
    } catch (error) {
        return error;
    }
}

async function getCompleteServicesByCodeRate(querySelector) {
    const search = {
        querySelector: querySelector
    }
    try {
        const res =await needAuth.post('/statics/service/codeRate', search)
        console.log(res)
        return await needAuth.post('/statics/service/codeRate', search);
    } catch (error) {
        return error;
    }
}

async function getPendingCount(querySelector) {
    const search = {
        querySelector: querySelector
    }
    try {
        return await needAuth.post('/statics/service/pendingCount', search);
    } catch (error) {
        return error;
    }
}

async function getFeedbackRate(querySelector) {
    const search = {
        querySelector: querySelector
    }
    try {
        return await needAuth.post('/statics/service/feedbackRate', search);
    } catch (error) {
        return error;
    }
}

// 서비스 공지사항
const getRequestNotice = async (gubun) => {
    try {
        return await needAuth.get(`/statics/service/notice/${gubun}`);
    } catch (error) {
        return error;
    }
}
// 서비스 자료실
const getRequestBulletin = async (gubun) => {
    try {
        return await needAuth.get(`/statics/service/bulletin/${gubun}`);
    } catch (error) {
        return error;
    }
}

// 요청처리율현황
const getHandlingOverview = async (search) => {
    try {
        return await needAuth.post(`/statics/service/handlingOverview`, search);
    } catch (error) {
        return error;
    }
}

const getFeedbackOverview = async (search, success) => {
    return apiRequest(() => needAuth.post(`/statics/service/feedbackOverview`, search), success)
}

export {
    getServiceCodeStatic,
    getServiceDetail,
    getServiceByStatus,
    getTimelyThroughput,
    getCompleteServicesByCodeRate,
    getPendingCount,
    getFeedbackRate,
    getRequestDoneCountByCode,
    getRequestDoneCountByHandlerDept,
    getRequestNotice,
    getRequestBulletin,
    getHandlingOverview,
    getFeedbackOverview
};